type MeasurementInputProps = {
  label: string;
  name: string;
  value: string | number;
  unitLabel: string;
  onValueChange: (value: string) => void;
  onUnitToggle: () => void;
  step?: number;
  min?: number;
};

const MeasurementInput = ({
  label,
  name,
  value,
  unitLabel,
  onValueChange,
  onUnitToggle,
  step,
  min
}: MeasurementInputProps) => {
  return (
    <div className="w-full">
      <label htmlFor={name} className="block mb-1 text-gray-600 text-sm font-medium">
        {label}
      </label>
      <div className="relative">
        <input
          id={name}
          name={name}
          type="number"
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
          className="w-full pr-14 py-3 pl-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-600"
          step={step}
          min={min}
        />
        <button
          type="button"
          onClick={onUnitToggle}
          className="absolute right-1 top-1/2 -translate-y-1/2 h-9 px-3 rounded-md border border-gray-200 bg-gray-50 text-xs font-semibold uppercase text-gray-600 hover:bg-gray-100"
        >
          {unitLabel}
        </button>
      </div>
    </div>
  );
};

export default MeasurementInput;
